import { Timeline, Text } from '@mantine/core';
import {
  IconCircleCheck,
  IconTruck,
  IconPackage,
  IconClipboardCheck,
  IconCircleDot,
} from '@tabler/icons-react';
import type { TrackingEvent } from '@/types';
import dayjs from 'dayjs';

const STATUS_ICONS: Record<string, React.ReactNode> = {
  confirmed: <IconClipboardCheck size={16} />,
  processing: <IconPackage size={16} />,
  picking: <IconPackage size={16} />,
  shipped: <IconTruck size={16} />,
  delivered: <IconCircleCheck size={16} />,
};

interface OrderTimelineProps {
  events: TrackingEvent[];
}

export default function OrderTimeline({ events }: OrderTimelineProps) {
  return (
    <Timeline active={events.length - 1} bulletSize={28} lineWidth={2}>
      {events.map((event, idx) => (
        <Timeline.Item
          key={idx}
          bullet={STATUS_ICONS[event.status.toLowerCase()] || <IconCircleDot size={16} />}
          title={event.status.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())}
        >
          <Text size="sm" c="dimmed">
            {event.description}
          </Text>
          {event.location && (
            <Text size="xs" c="dimmed">
              {event.location}
            </Text>
          )}
          <Text size="xs" c="dimmed" mt={4}>
            {dayjs(event.timestamp).format('MMM D, YYYY [at] h:mm A')}
          </Text>
        </Timeline.Item>
      ))}
    </Timeline>
  );
}
